import React, { useEffect } from 'react';
import { Tooltip } from 'antd';
import { Table } from '../../../base/Table';
import Btn from '../../../../../../components/btn';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import { useSearchParamsMethods } from '../../../../shared/packages/searchParamsManager';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import { useEvent } from '../../../../../../hooks/useEvent';
import { toInteger } from '../../../../shared/packages/searchParamsNormalizer';
import styles from './index.module.scss';

const ActionsCell = ({ record, column, row }) => {
  return (
    <Table.BodyCell column={column} row={row} className={styles.root}>
      <DetailedBtn record={record} />
    </Table.BodyCell>
  );
};

export default ActionsCell;

function DetailedBtn({ record }) {
  const { open, updateProps, getState } = useModalMethods();

  const { setParams, getParams } = useSearchParamsMethods();

  const handleClick = useEvent(() => {
    open(modalNames.roomInfoDrawer, { room: record });
    setParams({ [searchParamKeys.detailedInfoRoomId]: record?.id });
  });

  useEffect(() => {
    const isOpen = getState(modalNames.roomInfoDrawer)?.isOpen;

    const openedRoomId = toInteger(
      getParams(searchParamKeys.detailedInfoRoomId)
    );

    if (openedRoomId !== record.id) {
      return;
    }

    if (isOpen) {
      updateProps(modalNames.roomInfoDrawer, { room: record });
    } else {
      open(modalNames.roomInfoDrawer, { room: record });
    }
  }, [record, updateProps, getState, getParams, open, setParams]);

  return (
    <Tooltip
      title="Детальная информация"
      placement="topRight"
      arrowPointAtCenter
    >
      <Btn icon="menu" className={styles.btn} onClick={handleClick} />
    </Tooltip>
  );
}
